import { useState, useMemo, useRef, useEffect } from 'react';
import _ from 'underscore';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import services from "../../../services/services.js";
import { Urls } from "../../../services/Urls.js";
import { callautopopulate } from "../../../services/callautopop.js";
import { convertTo12HourFormat, dateConvert, formatDateObject } from '../../../utils/Helper.js';


export const useOutpassEntry = () => {

    const tagRef = useRef(null);
    const [rowData, setRowData] = useState([])
    const [total, setTotal] = useState({ total_applied: 0, total_approved: 0, total_rejected: 0, total_pending: 0, total_closed: 0 });
    const [pagination, setPagination] = useState({ displayPageOutOfTotal: "", currentPage: 0, totalRecords: 0, totalPages: 0 })
    const [showPagination, setshowPagination] = useState(false);
    const [userShiftTime, setUserShiftTime] = useState(null);
    const [loader, setloader] = useState(false);
    const [editUser, setEditUser] = useState({});
    const [showRequest, setShowRequest] = useState(false);
    const [showPendingRequest, setShowPendingRequest] = useState(false);
    const [filterValues, setFilterValues] = useState({ user: [], leave_type: [], request_to: [], approved_by: [], status: [], date: [] });
    const [filterOptions, setFilterOptions] = useState({ user: [], leave_type: [], approved_by: [], status: [] });
    const [isChange, setIsChange] = useState(false);
    const [columnDefs] = useState([
        {
            field: "edit",
            headerName: "Edit",
            width: 50,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>
                        {!params?.data?.is_approved && !params?.data?.is_rejected && !params?.data?.is_closed &&
                            <div className='c-pointer' onClick={() => { setEditUser(params?.data); setShowRequest(true); }}><FontAwesomeIcon icon="fa-solid fa-edit" /></div>
                        }
                    </div>
                )
            }
        },
        {
            field: "user_display_name",
            headerName: "Name",
            width: "30%",
            minWidth: 150,
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                return (
                    <div className='d-flex gap-1 align-items-center'>
                        <img src={params?.data?.user_image_url} alt="" width={20} height={20} className="rounded-circle" onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }}/>
                        <div>{params?.value} </div>
                    </div>

                )
            }
        },
        {
            field: "employee_id",
            headerName: "Employee Id",
            width: "35%",
            minWidth: 77,
            suppressHeaderMenuButton: true,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "apply_datetime",
            headerName: "Applied Date",
            width: "40%",
            minWidth: 150,
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                const date = new Date(params?.value);
                return (
                    <div style={{ textAlign: 'center' }} >{dateConvert(date, "date-time-months")}</div>
                )
            }
        },
        {
            field: "is_approved",
            headerName: "Status",
            width: "50%",
            minWidth: 20,
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                return (
                    <div style={{ textAlign: 'center' }}>
                        {params?.data?.is_closed ? <FontAwesomeIcon icon="fa-solid fa-circle-xmark" style={{ color: "#95a5a3" }} title='Request Closed'/> : params?.data?.is_approved ? <FontAwesomeIcon icon="fa-solid fa-thumbs-up" style={{ color: "#1aaf27" }} title='Approved'/> : params?.data?.is_rejected ? <FontAwesomeIcon icon="fa-solid fa-thumbs-down" style={{ color: "#e73e3e" }} title='Rejected'/> : (params?.data?.is_approved == null && params?.data?.is_rejected == null) ? <FontAwesomeIcon icon="fa-solid fa-hourglass-start" style={{ color: "#fdd63c" }} title='Pending'/> : ''}
                    </div>
                )
            }
        },
        {
            field: "leave_type_name",
            headerName: "Leave Type",
            width: "80%",
            minWidth: 90,
            suppressHeaderMenuButton: true,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "requested_to",
            headerName: "Requested To",
            width: "30%",
            minWidth: 100,
            suppressHeaderMenuButton: true,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "action_by",
            headerName: "Approved By",
            width: "30%",
            minWidth: 100,
            suppressHeaderMenuButton: true,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "leave_reason",
            headerName: "Reason",
            width: "90%",
            minWidth: 200,
            suppressHeaderMenuButton: true,
            cellRenderer: function (params) {
                return (
                    <div title={params?.value}>
                        {params?.value}
                    </div>
                );
            },
        },
        {
            field: 'user_out_datetime',
            headerName: "Out Time",
            minWidth: 70,
            width: "30%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            hide: false,
            cellRenderer: function (params) {
                return (
                    <div style={{ cursor: "pointer" }}>
                        {params?.value && convertTo12HourFormat(params?.value?.split("T")[1])}
                    </div>
                )
            }
        },
        {
            field: 'out_datetime',
            headerName: "Actual Out Time",
            minWidth: 70,
            headerClass: "header-wrap",
            width: "30%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            hide: false,
            cellRenderer: function (params) {
                return (
                    <div style={{ cursor: "pointer" }}>
                        {params?.value && convertTo12HourFormat(params?.value?.split("T")[1])}
                    </div>
                )
            }
        },
        {
            field: 'user_in_datetime',
            headerName: "In Time",
            minWidth: 70,
            width: "30%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            hide: false,
            cellRenderer: function (params) {
                return (
                    <div style={{ cursor: "pointer" }}>
                        {params?.value && convertTo12HourFormat(params?.value?.split("T")[1])}
                    </div>
                )
            }
        },
        {
            field: 'in_datetime',
            headerName: "Actual In Time",
            minWidth: 70,
            headerClass: "header-wrap",
            width: "30%",
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            hide: false,
            cellRenderer: function (params) {
                return (
                    <div style={{ cursor: "pointer" }}>
                        {params?.value && convertTo12HourFormat(params?.value?.split("T")[1])}
                    </div>
                )
            }
        },
    ])

    useEffect(() => {
        callautopopulate("users", "request_approver_leads", "gatepass_leave_types").then(res => {
            setFilterOptions((prev) => ({ ...prev, user: _.sortBy(_.uniq(res?.users, (item) => item?.user_code), "user_display_name"), leave_type: res?.gatepass_leave_types, request_to: res?.request_approver_leads, approved_by: res?.request_approver_leads, status: [{ status_name: "Pending", status_key: "pending" }, { status_name: "Approved", status_key: "approved" }, { status_name: "Rejected", status_key: "rejected" }, { status_name: "Closed", status_key: "closed" }] }))          
        })
    }, [])

    useEffect(() => {
        filterValues.apiCall && getGatePassDetails();
    }, [pagination?.currentPage, filterValues.apiCall])

    const getGatePassDetails = async (key) => {
        setloader(true)
        const payload = {
            requested_user_code: key === "user" ? "" : _.pluck(filterValues?.users, "user_code")?.toString() || "",
            page_number: pagination?.currentPage === 0 ? 0 : pagination?.currentPage - 1,
            leave_type_ids: key === "leave_type" ? "" : _.pluck(filterValues?.gatepass_leave_types, "leave_type_id")?.toString() || "",
            requestd_to: key === "request_to" ? "" : _.pluck(filterValues?.request_to, "user_code")?.toString() || "",
            action_by: key === "approved_by" ? "" : _.pluck(filterValues?.approved_by, "user_code")?.toString() || "",
            status: key === "status" ? "" : _.pluck(filterValues?.status, "status_key")?.toString() || "",
            from_date: filterValues?.date?.[0] ? formatDateObject(filterValues?.date?.[0]) : "",
            to_date: filterValues?.date?.[1] ? formatDateObject(filterValues?.date?.[1]) : "",
        };
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETGATEPASSDETAILS"), payload);
            if (res?.body?.data?.gatepass_data) {
                if (!_.isEmpty(res?.body?.data?.gatepass_data)) {
                    setshowPagination(true)
                }
                setRowData(res?.body?.data?.gatepass_data)
            }
            if (res?.body?.data?.gatepass_summary) {
                setTotal(res?.body?.data?.gatepass_summary?.[0])
            }
            if (res?.body?.data?.paging_info) {
                setPagination((prev) => ({ ...prev, totalRecords: res?.body?.data?.paging_info[0]?.total_issues, displayPageOutOfTotal: res?.body?.data?.paging_info[0]?.current_records, totalPages: res?.body?.data?.paging_info[0]?.paging }))
            }
            if (res?.body?.data?.user_shift_time) {
                setUserShiftTime( (res?.body?.data?.user_shift_time?.[0]))
            }
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            setloader(false);
        } catch (error) {
            console.error(error, "Error");
            setloader(false);
        }
    }


    return useMemo(() => ({
        tagRef, total, columnDefs, rowData, loader, showPagination, getGatePassDetails, showRequest, setShowRequest, showPendingRequest, setShowPendingRequest, filterValues, setFilterValues, filterOptions, isChange, setIsChange, editUser, setEditUser, pagination, setPagination, userShiftTime,
    }), [tagRef, total, columnDefs, rowData, loader, showPagination, getGatePassDetails, showRequest, setShowRequest, showPendingRequest, setShowPendingRequest, filterValues, setFilterValues, filterOptions, isChange, setIsChange, editUser, setEditUser, pagination, setPagination, userShiftTime])
}